import HttpClient from "../httpClient";
import { StandardItem, StandardFilter, CreateStandard, UpdateStandard } from "../../models/types/standard";
import { DefaultResponse, DefaultResponseContent, DefaultFilterRequest } from "../../models/types/common";

class StandardService {
    private service = HttpClient;

    async getAll(requestData: DefaultFilterRequest<StandardFilter>): Promise<DefaultResponseContent<StandardItem[]>> {
        const response = await this.service.get<DefaultResponseContent<StandardItem[]>>("/admin/Standard/GetAll", requestData);
        return response;
    }

    async getStandardById(id: string): Promise<DefaultResponse<StandardItem>> {
        const response = await this.service.get<DefaultResponse<StandardItem>>(`/admin/Standard/GetDetail/${id}`);
        return response;
    }

    async createStandard(requestData: CreateStandard): Promise<DefaultResponse<any>> {
        const response = await this.service.post<DefaultResponse<any>>(`/admin/Standard/Create`, requestData);
        return response;
    }

    async updateStandard(requestData: UpdateStandard): Promise<DefaultResponse<any>> {
        const response = await this.service.post<DefaultResponse<any>>(`/admin/Standard/Update`, requestData);
        return response;
    }

    async deleteStandard(id: number | string): Promise<DefaultResponse<any>> {
        const response = await this.service.delete<DefaultResponse<any>>(`/admin/Standard/Delete/${id}`);
        return response;
    }

}

const standardSvc = new StandardService();
export default standardSvc;
